module.exports = __webpack_public_path__ + "img/Edit Patient - Gray - Selected.646bbc4e.png";